var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1782_38068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 36C20 24.9543 28.9543 16 40 16H78C89.0457 16 98 24.9543 98 36V74C98 85.0457 89.0457 94 78 94H40C28.9543 94 20 85.0457 20 74V36Z",
    fill: "#F04343"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_38068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2751 66.8503C48.6867 66.8845 48.108 66.6889 47.6611 66.3047C46.7796 65.418 46.7796 63.986 47.6611 63.0993L66.9613 43.799C67.8781 42.9411 69.3166 42.9888 70.1745 43.9056C70.9502 44.7346 70.9954 46.0088 70.2803 46.8907L50.8663 66.3047C50.4252 66.6833 49.8558 66.8786 49.2751 66.8503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5516 66.8503C67.9552 66.8478 67.3836 66.6111 66.9602 66.1911L47.6599 46.8907C46.8433 45.9371 46.9543 44.502 47.9079 43.6853C48.759 42.9565 50.0142 42.9565 50.8653 43.6853L70.2792 62.9857C71.1957 63.8437 71.2431 65.2823 70.3851 66.1989C70.3509 66.2353 70.3157 66.2706 70.2792 66.3047C69.8038 66.7181 69.1782 66.9157 68.5516 66.8503Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1782_38068",
    x: 0,
    y: 0,
    width: 118,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368542 0 0 0 0 0.519173 0 0 0 0 0.7625 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1782_38068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1782_38068",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_38068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(47 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedTickets);
export default __webpack_public_path__ + "static/media/closed_tickets.c8054794ff53cb6e9803affeb5b7c54f.svg";
export { ForwardRef as ReactComponent };